export const TABLE_STATUS = {
  free: { label: "Libero", className: "bg-emerald-50 border-emerald-500 text-emerald-900", swatch: "#22C55E" },
  occupied: { label: "Occupato", className: "bg-red-50 border-red-500 text-red-900", swatch: "#EF4444" },
  bill: { label: "In conto", className: "bg-amber-50 border-amber-400 text-amber-950", swatch: "#F59E0B" },
  reserved: { label: "Prenotato", className: "bg-sky-50 border-sky-500 text-sky-900", swatch: "#3B82F6" },
};

export function tableStatusOf(t) {
  return TABLE_STATUS[t?.visual_status] || TABLE_STATUS[t?.open_order_id ? "occupied" : "free"];
}
